export default "__VITE_ASSET__213e795d__"